<template>
  <div class="d-flex">
    <DateInput
      v-model="dateFrom"
      class="mr-1"
      label="Date from"
    />
    <DateInput
      v-model="dateTo"
      class="ml-1"
      label="Date to"
    />
  </div>
</template>
<script>
import DateInput from './DateSelect.vue'

export default {
  components: { DateInput },
  props: {
    from: { type: Date, default: null },
    to: { type: Date, default: null }
  },
  data() {
    return {
      dateFrom: null,
      dateTo: null
    }
  },
  watch: {
    from: {
      immediate: true,
      handler(val) {
        if (!val) {
          return
        }
        this.dateFrom = val
      }
    },
    to: {
      immediate: true,
      handler(val) {
        if (!val) {
          return
        }
        this.dateTo = val
      }
    },
    dateFrom(val) {
      this.$emit('update:from', val)
    },
    dateTo(val) {
      this.$emit('update:to', val)
    }
  }
}
</script>
